import sensors from '@/utils/sensors'

export default {
    getQueryString(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
        var r = window.location.search.substr(1).match(reg)
        if (r != null) return unescape(r[2])
        return null
    },
    isEmpty(val, includeZero = false) {
        return val === '' || val === null || val === undefined || (includeZero && val === 0)
    },
    /**
     * 获取 browser 信息
     */
    getBrowser() {
        let ua = window.navigator.userAgent || ''
        let isAndroid = /android/i.test(ua)
        let isIos = /iphone|ipad|ipod/i.test(ua)
        let isWechat = /micromessenger\/([\d.]+)/i.test(ua)
        let isWeibo = /(weibo).*weibo__([\d.]+)/i.test(ua)
        let isQQ = /qq\/([\d.]+)/i.test(ua)
        let isQQBrowser = /(qqbrowser)\/([\d.]+)/i.test(ua)
        let isQzone = /qzone\/.*_qz_([\d.]+)/i.test(ua)
        // 安卓 chrome 浏览器，很多 app 都是在 chrome 的 ua 上进行扩展的
        let isOriginalChrome = /chrome\/[\d.]+ Mobile Safari\/[\d.]+/i.test(ua) && isAndroid
        let isOppo = /OppoBrowser\/[\d.]+/i.test(ua) && isAndroid
        let isVivo = /VivoBrowser\/[\d.]+/i.test(ua) && isAndroid
        let isXiaoMi = /XiaoMi\/MiuiBrowser\/[\d.]+/i.test(ua) && isAndroid
        let isHUAWEI = /HUAWEI+/i.test(ua)
        let isSougoBrowser = /SogouMobileBrowser+/i.test(ua)
        let isUCBrowser = /UCBrowser+/i.test(ua)
        let isBaiduBrowser = /baidu+/i.test(ua)

        // chrome for ios 和 safari 的区别仅仅是将 Version/<VersionNum> 替换成了 CriOS/<ChromeRevision>
        // ios 上很多 app 都包含 safari 标识，但它们都是以自己的 app 标识开头，而不是 Mozilla
        let isSafari = /safari\/([\d.]+)$/i.test(ua) && isIos && ua.indexOf('Crios') < 0 && ua.indexOf('Mozilla') === 0
        let isAndroidApp = /PPDWebUI/i.test(ua) && isAndroid
        let isiOSApp = /PPDWebUI/i.test(ua) && isIos

        return {
            isAndroid: isAndroid,
            isIos: isIos,
            isWechat: isWechat,
            isWeibo: isWeibo,
            isQQ: isQQ,
            isQQBrowser: isQQBrowser,
            isQzone: isQzone,
            isOriginalChrome: isOriginalChrome,
            isOppo: isOppo,
            isVivo: isVivo,
            isXiaoMi: isXiaoMi,
            isHUAWEI: isHUAWEI,
            isSougoBrowser:isSougoBrowser,
            isUCBrowser: isUCBrowser,
            isBaiduBrowser: isBaiduBrowser,
            isSafari: isSafari,
            isAndroidApp: isAndroidApp,
            isiOSApp: isiOSApp
        }
    },
    isWeixin() {
        // 判断是否是微信
        var ua = navigator.userAgent.toLowerCase()
        var isWeixin = ua.indexOf('micromessenger') !== -1
        if (isWeixin) {
            return true
        } else {
            return false
        }
    },
    /**
     * 获取 ios 大版本号
     */
    getIOSVersion() {
        let verion = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        return parseInt(verion[1], 10);
    },
    /**
     * 获取cookie
     */
    getCookie (cookieName) {
        let strCookie = document.cookie
        let arrCookie = strCookie.split(';')
        for (var i = 0; i < arrCookie.length; i++) {
            var arr = arrCookie[i].split('=')
            if (cookieName === arr[0].replace(/^\s*/g, '')) {
                return arr[1]
            }
        }
        return ''
    },
    isLogin() {
        let token = this.getCookie('token')
        if (token) {
            return true
        } else {
            return false
        }
    },
    // 神策埋点 h5_clk
    doSensors (params) {
        let initSensorsData = {
            page: '',
            tgt_type: '', // 元素类型
            tgt_name: '', // 元素名称
            tgt_event_id: '', // 元素ID
            target_url: '', // 元素链接地址
            url: window.location.href, // 页面地址
            position: '' // 非必传参数
        }
        Object.assign(initSensorsData, params)
        sensors.track('h5_clk', initSensorsData)
    },

    // 神策埋点 h5_element_imp
    doElementImp (params) {
        let initSensorsData = {
            page: '',
            tgt_type: '',
            tgt_name: '',
            tgt_event_id: '',
            url: window.location.href, // 页面地址
            position: '' // 非必传
        }
        Object.assign(initSensorsData, params)
        sensors.track('h5_element_imp', initSensorsData)
    },
    doSensorsTrack (method, params) {
        let initSensorsData = {
            page: '',
            tgt_type: '',
            tgt_name: '',
            tgt_event_id: '',
            url: window.location.href, // 页面地址
            position: '' // 非必传
        }
        Object.assign(initSensorsData, params)
        sensors.track(method, initSensorsData)
    },
}
